exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.select2-selection__rendered {\n  background-color: #eff4fd !important;\n}\n.select2-dropdown {\n  background-color: #eff4fd !important;\n}\n.select2-container--default .select2-selection--multiple {\n  border: none;\n}\n.select2-container--default.select2-container--focus .select2-selection--multiple {\n  border: none;\n}\n.vs--single .vs__selected {\n  margin: 0;\n}\ninput[type=\"search\"] {\n  -webkit-appearance: none;\n  margin: 0;\n}\n", ""]);

// exports
